document.addEventListener('DOMContentLoaded', function load() {
 
   function replacePWimages(selector) {
    var textArray = $(selector);
    console.log(textArray);
    textArray.each(function () {
        var text = $(this).text();
        var cardIDMatch = text.match(/PersonalisationID:\s*([^\s]+)/);
        console.log(cardIDMatch);
        if (cardIDMatch && cardIDMatch[1]) {
            var cardID = cardIDMatch[1];
            console.log(cardID);
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/11734/" + cardID + ".jpg?r=" + rand;

            var $img = $(this).parent().find("img");
            $(this).parent().addClass("pwProductItem");
            $img.addClass("pwThumbImage");
            $img.attr("src", newSrc);
            $img.attr("srcset", newSrc);
        }
    });
}

  /*if($("body").hasClass("template-cart")){
    // Call the function with your target selector
     replacePWimages(".cart-items .cart-item .cart-item__details");
  }*/

    $(document).on("click", ".header__icons #cart-icon, .product-info__add-button button", function(){
       
        setTimeout(function(){ 
        	replacePWimages(".cart-drawer__content .cart-items .cart-item .cart-item__details");
        },2000);
    });
    $(document).on("click", ".pwEditOrderLink", function(e){
        e.preventDefault();
    });

}, false);